<template>
   <div>
        <h3>Further Info</h3>
        <p class="margin_bottom">Based on the selected amenities provide the following details</p>
        <div class="md-layout">
            <div class="md-layout-item md-size-100" v-for="group in amenityGroupsSelected" :key="group.name">
                <h4 class="card-title amentity_group_title">{{ group.name }}</h4>
                <div v-for="amenity in group.itemsSelected" :key="amenity.name" class="amenity_details">
                    <component v-bind:is="amenity.component" :amenity="amenity"></component>
                </div>
            </div>   
        </div>
    </div>  
</template>    
<script>
    import GroupWrap from "@/ts/amenitiesTypes";

    import AmenityText from "./Amenities/AmenityText.vue";
    import AmenityRadio from "./Amenities/AmenityRadio.vue";
    import AmenityCheckbox from "./Amenities/AmenityCheckbox.vue";
    import AmenityNumber from "./Amenities/AmenityNumber.vue";
    import AmenityChips from "./Amenities/AmenityChips.vue";
    import AmenityRadioText from "./Amenities/AmenityRadioText.vue";
    import AmenityRadioTextTextText from "./Amenities/AmenityRadioTextTextText.vue";
    import AmenityCheckboxText from "./Amenities/AmenityCheckboxText.vue";
    import AmenityNumberText from "./Amenities/AmenityNumberText.vue";
    import AmenityChipsText from "./Amenities/AmenityChipsText.vue";
    import AmenityRadioNumberText from "./Amenities/AmenityRadioNumberText.vue";
    import AmenityRadioChipsText from "./Amenities/AmenityRadioChipsText.vue";
    import AmenityCheckboxRadioText from "./Amenities/AmenityCheckboxRadioText.vue";


    export default {
        name: "BuildingAmenitiesDetails",
        components: {
              AmenityText
            , AmenityRadio
            , AmenityCheckbox
            , AmenityNumber
            , AmenityChips
            , AmenityRadioText
            , AmenityRadioTextTextText
            , AmenityCheckboxText
            , AmenityNumberText
            , AmenityChipsText
            , AmenityRadioNumberText
            , AmenityRadioChipsText
            , AmenityCheckboxRadioText
        },
        props: {
            amenities: {
                groups : Array
            }
        },
        computed: {
            amenityGroupsSelected() {
                return this.amenities.groups.filter(g => {return g.anySelected;});
            }
        },
        created() {
            this.amenities.groups = this.amenities.groups.map(g => new GroupWrap(g)); //this combined with handing whole amenities object into the prop seems to avoid mutating props crap and any additional complexity, seems to be in sync fine !!!
        }
    };
</script>
<style>
    .amenity_details {
        margin-bottom: 3rem;
    }

    .count {
        margin-left: 1rem;
    }

    .btn_counter { /*was .md-button.md-just-icon */
        height: 30px;
    }

    .md-chip .md-ripple {
        text-transform: none;
    }

    .md-card .md-card-actions {
        border: none;
    }


    .md-card .md-card-content .md-form-label.top_pad_none {
        padding-top: 0px;
    }

    .md-card .md-card-content .md-form-label.top_pad_min {
        padding-top: 10px;
    }

    .md-card .md-card-content .md-form-label.top_pad {
        padding-top: 30px;
    }

    .md-inline-checkboxes {
        display: inline-flex;
        .md-checkbox{
            margin-top: 15px !important;
        }
    }

    .md-checkbox,
    .md-radio {
        margin-top: 0rem;
        margin-bottom: 0.5rem;
    }

    .md-checkbox,
    .md-radio {
        display: flex;
    }

        .md-radio .md-radio-container {
            margin-left: 5px;
            position: relative;
            left: -3px;
        }

    .md-form-label + .md-layout-item .md-checkbox:not(:first-child),
    .md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
    .md-form-label + .md-layout-item .md-radio {
        margin-top: 0;
    }

    .md-chip.md-theme-default.md-duplicated {
        background-color: #ff5252 !important;
        background-color: var(--md-theme-demo-light-accent,#ff5252) !important;
    }
</style>